// extracted by css-extract-rspack-plugin
export default {"field":"KklT_l"};